import { map, path, pipe, prop, flatten } from 'ramda';

export const mergeCareTeam = pipe(
  path(['response', 'entry']),
  map(path(['resource', 'participant'])),
  flatten,
  map(prop('member')),
);
